import { Component, Prop, Vue } from "vue-property-decorator";
import Card from "@/components/Card.tsx";
import { CreateElement } from "vue";
import ChartTypes from "@/components/ChartTypes.tsx";
import DashboardDataGenerator from "../../DashboardDataGenerator";

@Component
export default class ReadingExplicit extends Vue {
  @Prop({ default: null }) data: any; // data to inject into chart

  private dataGen!: DashboardDataGenerator;
  private refId = "balaReading";
  private chartId = "bala-reading";
  private arrAvg: any;

  private labels: any;
  private lineLabelToggle: boolean = false;

  private chartData = {
    type: "horizontalBar",
    labels: [],
    data: { labels: [], datasets: [] },
    options: {
      responsive: true,
      barValueSpacing: 20,
      lineTension: 1,
      legend: {
        display: false
      },
      scales: {
        yAxes: [
          {
            id: "y-axis-0",
            scaleLabel: {
              display: false,
              labelString: "Criterion"
            },
            ticks: {
              beginAtZero: true,
              padding: 25
            }
          }
        ],
        xAxes: [
          {
            id: "x-axis-0",
            scaleLabel: {
              display: true,
              labelString: "Percentage of Questions Answered Correctly (%)"
            },
            ticks: {
              beginAtZero: true,
              suggestedMax: 100
            }
          }
        ]
      },
      annotation: {
        events: ["mouseover", "mouseout"],
        annotations: []
      }
    }
  };

  private lineAnnotation(mean: number, labelToggle: boolean) {
    return {
      type: "line",
      drawTime: "afterDatasetsDraw",
      id: "vline1",
      mode: "vertical",
      scaleID: "x-axis-0",
      value: mean,
      borderColor: "black",
      borderWidth: 2,
      label: {
        enabled: false,
        content: `Class Average: ${mean}%`
      },
      onMouseover: function(e: any) {
        var element: any = this;
        element.options.label.enabled = true;
        element.chartInstance.update();
      },
      onMouseout: function(e: any) {
        var element: any = this;
        element.options.label.enabled = false;
        element.chartInstance.update();
      }
    };
  }

  sort(labels: string[], score: number[], type: "ascending" | "descending") {
    const data_unf: any = this.data["students"];
    let isAscending = type == "ascending" ? true : false;
    let labelComp = function(a: string, b: string) {
      return scoreComp(data_unf[a].percent, data_unf[b].percent);
    };
    let scoreComp = function(a: number, b: number) {
      return a >= b ? (isAscending ? 1 : -1) : isAscending ? -1 : 1;
    };
    labels.sort(labelComp);
    score.sort(scoreComp);
  }

  async mounted() {
    const data_unf: any = this.data["students"];
    let labels = [];
    let score: any = [];

    for (let names in data_unf) {
      labels.push(names);
      score.push(data_unf[names].percent);
    }

    // sort score and labels
    this.sort(labels, score, "descending");

    let dataset = [
      {
        backgroundColor: this.data["color"],
        data: score
      }
    ];

    let annotation: any = this.lineAnnotation(
      this.data["mean"],
      this.lineLabelToggle
    );
    (this.chartData.options.annotation.annotations as any).push(annotation);
    (this.chartData.data.datasets as any) = dataset;
    (this.chartData.data.labels as any) = labels;
    (this.$refs[this.refId] as any).forceRefresh();
  }

  render(h: CreateElement) {
    return (
      <v-card>
        <v-card-title class="mx-auto text-center">
          {this.data["label"]}
        </v-card-title>
        <v-card-text>
          <ChartTypes
            chartId={this.chartId}
            chartData={this.chartData}
            ref={this.refId}
          ></ChartTypes>
          <br />
        </v-card-text>
      </v-card>
    );
  }
}

const component = ReadingExplicit;
